export const WORKING_HOURS_DAYS = [
  { key: "monday", label: "Senin" },
  { key: "tuesday", label: "Selasa" },
  { key: "wednesday", label: "Rabu" },
  { key: "thursday", label: "Kamis" },
  { key: "friday", label: "Jumat" },
  { key: "saturday", label: "Sabtu" },
  { key: "sunday", label: "Minggu" }
];

const SAFE_AGENT_BACK_PATHS = [
  "/agent-ai-v2",
  "/agent-ai-v2/create",
  "/agent-ai-v2/edit"
];

const LEGACY_AGENT_BACK_PATHS = {
  "/working-chat/list": "/automation/working-chat/list",
  "/away-chat/list": "/automation/away-chat/list",
  "/automation/working-chat/list": "/automation/working-chat/list",
  "/automation/away-chat/list": "/automation/away-chat/list"
};

function dayField(day, suffix) {
  return "wh_" + day.key + "_" + suffix;
}

function timeToMinutes(value) {
  const text = String(value == null ? "" : value).trim();
  const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(text);
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

export function normalizeWorkingHours(data) {
  const source = data || {};
  const days = {};
  WORKING_HOURS_DAYS.forEach(day => {
    const rawStatus = Number(source[dayField(day, "status")]);
    days[day.key] = {
      status: isNaN(rawStatus) ? 0 : rawStatus,
      start: String(source[dayField(day, "start")] || "").trim(),
      end: String(source[dayField(day, "end")] || "").trim()
    };
  });
  return {
    id: source.id == null ? "" : String(source.id),
    memberId: Number(source.member_id) || 0,
    days: days
  };
}

export function validateWorkingHours(data) {
  const normalized = data && data.days ? data : normalizeWorkingHours(data);
  const errors = [];
  let activeCount = 0;

  WORKING_HOURS_DAYS.forEach(day => {
    const item = normalized.days[day.key] || {};
    const status = Number(item.status);
    if (status !== 0 && status !== 1) {
      errors.push(day.label + ": status hari tidak valid.");
      return;
    }
    if (status !== 1) return;

    activeCount += 1;
    const start = String(item.start || "").trim();
    const end = String(item.end || "").trim();
    if (!start || !end) {
      errors.push(day.label + ": jam buka dan jam tutup wajib diisi.");
      return;
    }
    const startMinutes = timeToMinutes(start);
    const endMinutes = timeToMinutes(end);
    if (startMinutes === null || endMinutes === null) {
      errors.push(day.label + ": format jam harus HH:MM.");
      return;
    }
    if (startMinutes >= endMinutes) {
      errors.push(day.label + ": jam tutup harus lebih lambat dari jam buka.");
    }
  });

  if (activeCount === 0) {
    errors.unshift("Belum ada hari operasional yang aktif.");
  }

  return Object.assign({}, normalized, {
    isConfigured: !!normalized.id || activeCount > 0,
    activeCount: activeCount,
    errors: errors,
    isValid: errors.length === 0,
    message: errors.length ? errors[0] : ""
  });
}

function displayTime(value) {
  return String(value || "").replace(":", ".");
}

function groupLabel(rows) {
  if (rows.length === 1) return rows[0].label;
  return rows[0].label + "–" + rows[rows.length - 1].label;
}

export function workingHoursSummary(data) {
  const normalized = data && data.days ? data : normalizeWorkingHours(data);
  const groups = [];

  WORKING_HOURS_DAYS.forEach(day => {
    const item = normalized.days[day.key] || {};
    const active = Number(item.status) === 1;
    const key = active ? "active|" + item.start + "|" + item.end : "off";
    const last = groups[groups.length - 1];
    const row = {
      label: day.label,
      active: active,
      start: item.start,
      end: item.end,
      key: key
    };
    if (last && last.key === key) {
      last.rows.push(row);
    } else {
      groups.push({ key: key, active: active, rows: [row], start: row.start, end: row.end });
    }
  });

  return groups.map((group, index) => ({
    key: group.key + "|" + index,
    label: groupLabel(group.rows),
    active: group.active,
    text: group.active
      ? displayTime(group.start) + "–" + displayTime(group.end)
      : "Libur"
  }));
}

export function safeWorkingHoursBackPath(value) {
  let back = Array.isArray(value) ? value[0] : value;
  if (back == null) return "";
  back = String(back).trim();
  if (!back || back.charAt(0) !== "/" || back.charAt(1) === "/") return "";
  if (back.indexOf("\\") !== -1 || /[\u0000-\u001f]/.test(back)) return "";

  const hashIndex = back.indexOf("#");
  if (hashIndex >= 0) back = back.slice(0, hashIndex);
  const queryIndex = back.indexOf("?");
  let pathname = queryIndex >= 0 ? back.slice(0, queryIndex) : back;
  const search = queryIndex >= 0 ? back.slice(queryIndex) : "";

  if (pathname.length > 1 && pathname.charAt(pathname.length - 1) === "/") {
    pathname = pathname.slice(0, -1);
  }
  if (pathname.indexOf("..") !== -1 || pathname.indexOf("//") !== -1) return "";

  if (LEGACY_AGENT_BACK_PATHS[pathname]) {
    return LEGACY_AGENT_BACK_PATHS[pathname];
  }
  if (SAFE_AGENT_BACK_PATHS.indexOf(pathname) === -1) return "";
  return pathname + search;
}



// WEBPACK FOOTER //
// ./src/views/ai/agentV2/workingHours.js